import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { IFsLprProvidersInterface } from '../interfaces/lpr-provider.interface';

export class LprProvidersModel extends SnModel {
  @Expose()
  public results: IFsLprProvidersInterface[];

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
